import { DOCTYPE } from './docTypeConstants';

export const BASE_URL = `${window.location.origin}`;

/**
 * Ordered list of URL path patterns mapped to tab docTypes.
 * More-specific paths must come before less-specific ones so that
 * matchPathToTab() picks the right pattern first.
 */
export const URL_PATTERNS = [
  // Projects — sub-pages before the dashboard root
  { path: '/projects/:projectId/setup',                    docType: DOCTYPE.PROJECT_SETUP },
  { path: '/projects/:projectId/assignment',               docType: DOCTYPE.PROJECT_ASSIGNMENT },
  { path: '/projects/:projectId/adrs/:docId',              docType: DOCTYPE.ADR },
  { path: '/projects/:projectId/adrs',                     docType: DOCTYPE.ADR_LIST },
  { path: '/projects/:projectId/pay-estimates/:docId',     docType: DOCTYPE.PROJECT_PAY_ESTIMATE_DETAIL },
  { path: '/projects/:projectId/pay-estimates',            docType: DOCTYPE.PROJECT_PAY_ESTIMATES },
  { path: '/projects/:projectId/qsheets/:docId',           docType: DOCTYPE.PROJECT_QSHEET },
  { path: '/projects/:projectId/reports/labor-weekly',     docType: DOCTYPE.REPORT_LABOR_WEEKLY },
  { path: '/projects/:projectId/reports/contractor-weekly',docType: DOCTYPE.REPORT_CONTRACTOR_WEEKLY },
  { path: '/projects/:projectId/reports/work-performed',   docType: DOCTYPE.REPORT_WORK_PERFORMED },
  { path: '/projects/:projectId/reports/item-estimates',   docType: DOCTYPE.REPORT_ITEM_EST_QUANTITIES },
  { path: '/projects/:projectId/reports/comment-keyword',  docType: DOCTYPE.REPORT_COMMENT_KEYWORD },
  { path: '/projects/:projectId/overtime',                 docType: DOCTYPE.OVERTIME_LIST },
  { path: '/projects/:projectId',                          docType: DOCTYPE.PROJECT_DASH },
  { path: '/projects',                                     docType: DOCTYPE.PROJECT_LIST },
  // ADR search (not deep-linkable — URL syncs but fresh-load shows error)
  { path: '/adrs/search',                                  docType: DOCTYPE.ADR_SEARCH_RESULTS },
  // Singleton / global pages
  { path: '/overtime',                                     docType: DOCTYPE.OVERTIME_LIST },
  { path: '/reports',                                      docType: DOCTYPE.REPORT_SELECTION },
  { path: '/issues/:docId',                                docType: DOCTYPE.ISSUE_THREAD },
  { path: '/issues',                                       docType: DOCTYPE.ISSUE_TRACKER },
  { path: '/notifications',                                docType: DOCTYPE.NOTIF_CENTER },
  { path: '/preferences',                                  docType: DOCTYPE.USER_PREFERENCES },
  { path: '/qms/admin',                                    docType: DOCTYPE.QMS_ADMIN },
  { path: '/qms/cmt',                                      docType: DOCTYPE.QMS_CHANGE_MANAGEMENT_TRACKER_LIST },
  { path: '/qms',                                          docType: DOCTYPE.QMS_DASHBOARD },
  { path: '/admin',                                        docType: DOCTYPE.ADMIN_TASKS },
  { path: '/about',                                        docType: DOCTYPE.ABOUT },
  { path: '/',                                             docType: 'HOME' },
];
